import classNames from "classnames";
import {
  InputNumber,
  InputNumberChangeEvent,
  InputNumberProps
} from "primereact/inputnumber";
import React, { useMemo } from "react";
import { toWSMoneyString } from "../../../utils";
import { getFsExcludeClassName } from "../../../utils/getFsExcludeClassName";
import { getInputTestIdByName } from "../../../utils/getInputTestIdByName";
import { WSInputBaseProps } from "../../types/forms";
import { detachFieldProps, WSField, WSFieldProps } from "../WSField/WSField";
import {
  WSInputContainer,
  WSInputContainerProps
} from "../WSInputContainer/WSInputContainer";
import styles from "./styles.module.scss";

export type WSInputNumberProps = WSInputBaseProps<
  number | null,
  InputNumberChangeEvent
> &
  WSFieldProps &
  WSInputContainerProps &
  Omit<
    InputNumberProps,
    | "pt"
    | "prefix"
    | "size"
    | "color"
    | "onChange"
    | "onBlur"
    | "onFocus"
    | "mode"
  >;

export const WSInputNumber = React.forwardRef<InputNumber, WSInputNumberProps>(
  (props, ref) => {
    const {
      name,
      status,
      align,
      size = "M",
      className,
      icon,
      placeholder = "0",
      iconRight,
      inputAction,
      disabled,
      onChange,
      fsExclude,
      inputClassName,
      ...otherProps
    } = props;

    const { fieldProps, currency, ...inputProps } = detachFieldProps(
      otherProps
    );

    const currencySymbol = useMemo(() => {
      if (!currency) {
        return;
      }

      try {
        return toWSMoneyString(0, "default", currency).replace("0.00", "");
      } catch {
        return;
      }
    }, [currency]);

    return (
      <WSField {...fieldProps} status={status}>
        <WSInputContainer
          status={status}
          align={align}
          size={size}
          icon={icon}
          iconRight={iconRight}
          inputAction={inputAction}
          disabled={disabled}
          className={className}
          prefix={currencySymbol}
        >
          <InputNumber
            ref={ref}
            name={name}
            disabled={disabled}
            onChange={(e) => onChange(e.value, e)}
            className={classNames(
              inputClassName,
              getFsExcludeClassName(fsExclude),
              styles.span
            )}
            data-testid={getInputTestIdByName(name)}
            placeholder={placeholder}
            {...inputProps}
          />
        </WSInputContainer>
      </WSField>
    );
  }
);

WSInputNumber.displayName = "WSInputNumber";
